import { fg } from '@atlassian/jira-feature-gating';

const NinFieldCellExtractionRelayProvider = {
	get(): boolean {
		return fg('nin_field_cell_extraction');
	},
};

export default NinFieldCellExtractionRelayProvider;
